import { ChangeDetectorRef, Component, ElementRef, Input, QueryList, Renderer2, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { faArrowDownToLine, faList, faPaperclip, faListTree, faFileCircleInfo, faGridHorizontal, faCircleArrowRight, faChevronDown, faChevronUp, faPlus, faMinus } from '@fortawesome/pro-light-svg-icons';
import { TableConfig } from '../../../components/table/table-config.interface';
import { TableComponent } from '../../../components/table/table.component';
import { HelpersService } from '../../../services/helpers.service';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DetalleFactura, DocumentoAsociado } from '../../../interfaces/documento-factura.interface';
import { IconActionComponent } from '../../../components/icon-action/icon-action.component';
import { CarouselComponent } from '../../../components/carousel/carousel.component';
import { CarouselItem } from '../../../components/carousel/carousel.interface';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { ImpresionService } from '../../../services/impresion.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoaderSpinnerComponent } from '../../../components/loader-spinner/loader-spinner.component';
import { ModalComponent } from '../../../components/modal/modal.component';
import { TabComponent } from '../../../components/tab/tab.component';
import { FacturaService } from '../../../services/factura.service';
import { DetalleAnticipoAsociado, DetalleAnticipos, DetalleAvanceAsociado, DetalleAvanceLinea, DetalleOcAsociada, DetalleOcLinea, DetalleRetencionAsociada, DetalleRetenciones } from '../../../interfaces/documento-asociado.interface';
import { TipoDocumento } from '../../../enums/helpers-enum';
import { FormatearNumeroPipe } from '../../../pipes/formatear-numero.pipe';
import { ContenidoCarucelComponent } from './contenido-carucel/contenido-carucel.component';
import { DatosDocumentoAttach } from '../../../models/documento-attach.models';
import { RespuestaDocumentoAttach } from '../../../interfaces/documento-attach.interface';
import { SnackBarComponent } from '../../../components/snack-bar/snack-bar.component';



@Component({
  selector: 'contenido-documento',
  standalone: true,
  imports: [NgxImageZoomModule, PdfViewerModule, TableComponent, CommonModule, FlexLayoutModule, IconActionComponent, CarouselComponent, FontAwesomeModule, LoaderSpinnerComponent, ModalComponent, TabComponent, FormatearNumeroPipe, ContenidoCarucelComponent, SnackBarComponent],
  templateUrl: './contenido-documento.component.html',
  styleUrl: './contenido-documento.component.scss'
})
export class ContenidoDocumentoComponent {

  @Input() listDocAsociados: DocumentoAsociado[] = [];
  @Input() detalleFact!: DetalleFactura;
  @Input() idOrgc: string = "";
  @Input() idDoc: string = "";
  @Input() idTipoDoc: string = "";

  @ViewChildren('dynamicTemplate') dynamicTemplates!: QueryList<TemplateRef<any>>;
  templatesArray: TemplateRef<any>[] = [];


  @ViewChild('tab1Template') tab1Template!: TemplateRef<any>;
  @ViewChild('tab2Template') tab2Template!: TemplateRef<any>;
  @ViewChild('tab3Template') tab3Template!: TemplateRef<any>;

  @ViewChild('item1') item1!: TemplateRef<any>;
  @ViewChild('item2') item2!: TemplateRef<any>;
  @ViewChild('item3') item3!: TemplateRef<any>;
  @ViewChild('item4') item4!: TemplateRef<any>;

  @ViewChild('itemDetalle1') itemDetalle1!: TemplateRef<any>;
  @ViewChild('itemDetalle2') itemDetalle2!: TemplateRef<any>;
  @ViewChild('itemDetalle3') itemDetalle3!: TemplateRef<any>;

  @ViewChild('itemDetallado1') itemDetallado1!: TemplateRef<any>;
  @ViewChild('itemDetallado2') itemDetallado2!: TemplateRef<any>;
  @ViewChild('itemDetallado3') itemDetallado3!: TemplateRef<any>;
  

  tabs = [
    { name: 'tab1', label: 'Recepciones' },
    { name: 'tab2', label: 'Estados de Pago' }
  ];

  opcionesList = [
    { name: "Previsualización", value: " 1", select: true },
    { name: "Listado de documentos", value: "2" },
    { name: "Listado de detalle", value: "3" }
  ];

  dataConfigListCheck: TableConfig = {
    config: [
      { header: '', key: 'check', isCheckBox: true, isAccionCheck: true, keyDisabledCheck:'disabledItem'},
      { header: 'Documento', key: 'DescripcionDocumentoNroDocumento', disableClick:true},
      { header: 'Fecha creación', key: 'FechaCreacionFormato', disableClick:true},
      { header: 'PDF', key: 'xml', labelChipsIcon: { icon: faPaperclip, titleTooltip: "Descargar PDF", loader:true }, loaderChips:'loader', errorChips: 'error', disableClick:true},
      { header: 'Archivo adjunto', key: 'CantidadAdjuntos', labelChipsIcon: { icon: faPaperclip, titleTooltip: "Descargar Adjunto", loader:true }, loaderChips:'loaderAdjuntos', errorChips: 'errorAdjuntos', disableClick:true }
    ],
    accion: [],
    name: "usuario",
    nameMensageTable: "direcciones",
    initialMessage: { active: false, message: "hola" },
    delete: false
  };

  dataConfigListAvance: TableConfig = {
    config: [
      { header: 'Avance', key: 'NumeroDocumento' },
      { header: 'Sucontrato', key: 'NumeroSubcontrato' },
      { header: 'Código Item', key: 'CodigoItem' },
      { header: 'Descripción', key: 'Descripcion' },
      { header: 'Glosa', key: 'Glosa' },
      { header: 'Cant.', key: 'Cantidad' },
      { header: 'Un', key: 'Unidad' },
      { header: 'Cuenta de costo', key: 'precio' },
      { header: ' Partida', key: 'DescripcionTipoDoc' },
      { header: 'Precio.', key: 'MontoUnitario' },
      { header: 'Total.', key: 'MontoNetoOrigen' },
      { header: 'Total Neto.', key: 'MontoAvance' },
    ],
    accion: [],
    name: "Avance",
    nameMensageTable: "Avances",
    initialMessage: { active: false, message: "hola" },
    delete: false,
    MensageSimple: true
  };

  dataConfigListRecepciones: TableConfig = {
    config: [
      { header: 'Recepción', key: 'Codigo' },
      { header: 'Órden de compra', key: 'NumeroOc' },
      { header: 'Código', key: 'codigo' },
      { header: 'Descripción', key: 'Descripcion' },
      { header: 'Glosa', key: 'glosa' },
      { header: 'Cantidad', key: 'Cantidad' },
      { header: 'Unidad', key: 'Unidad' },
      { header: 'Precio', key: 'PrecioUnitario' },
      { header: ' Total Recibido', key: 'TotalRecibido' },
      { header: ' Partida', key: 'DescripcionPartida' }
    ],
    accion: [],
    name: "recepcion",
    nameMensageTable: "Recepciones",
    initialMessage: { active: false, message: "hola" },
    delete: false,
    MensageSimple: true
  };

  dataConfigListEstadoAnticipo: TableConfig = {
    config: [
      { header: 'Anticipo', key: 'NumeroDocumento' },
      { header: 'Sucontrato', key: 'NumeroSubcontrato' },
      { header: 'Nombre', key: 'NombreDocumento' },
      { header: 'Total anticipo', key: 'MontoNetoOrigen' },
      { header: 'Por pagar', key: 'SaldoAPagar' },
      { header: 'Total pagado', key: 'MontoNeto' }
    ],
    accion: [],
    name: "Anticipo",
    nameMensageTable: "Anticipo",
    initialMessage: { active: false, message: "hola" },
    delete: false,
    MensageSimple: true
  };

  dataConfigListEstadoRetencion: TableConfig = {
    config: [
      { header: 'Retención', key: 'NumeroDocumento' },
      { header: 'Sucontrato', key: 'NumeroSubcontrato' },
      { header: 'Nombre', key: 'NombreDocumento' },
      { header: 'Acordado', key: 'MontoAcordado' },
      { header: 'Por pagar', key: 'MontoPorPagar' },
      { header: 'Total pagado', key: 'MontoPagado' },
      { header: 'Ajustes', key: 'MontoNetoAjuste' }
    ],
    accion: [],
    name: "Retencion",
    nameMensageTable: "Retención",
    initialMessage: { active: false, message: "hola" },
    delete: false,
    MensageSimple: true
  };

  dataListado = {
    listTable: [] as DocumentoAsociado[],
    isOpen: false
  };

  dataListadoRelacion = {
    listTable: [] as DetalleOcLinea[],
    isOpen: false
  };

  dataListadoAvance = {
    listTable: [] as DetalleAvanceLinea[],
    isOpen: false
  };

  dataListadoEstadoAnticipo = {
    listTable: [] as DetalleAnticipos[],
    isOpen: false
  };

  dataListadoEstadoRetencion = {
    listTable: [] as DetalleRetenciones[],
    isOpen: false
  };

  carouselContent: any[] = [];
  carouselContentDetallado: CarouselItem[] = [];

  isPopupVisible: boolean = false;
  popupPosition: number = 0;
  iconTotalPendiente = faChevronDown;
  iconTotalNotas = faChevronDown;
  showDataNotas: boolean = false;
  showDataPendientes: boolean = false;
  pdfSourceView: string = ''

  pdfSource: string = '';
  thumbnail: string = '';
  fullImage: string = '';

  pdfSource2: string = '';
  thumbnail2: string = '';
  fullImage2: string = '';

  nameFileDownload: string = 'archivo.pdf';

  tabActive: string = "tab1";
  faArrowDownToLine = faArrowDownToLine;
  iconList = faGridHorizontal;
  faCircleArrowRight = faCircleArrowRight;
  mensajeTooltipsList = "Tipo de visualización de documentos.";
  faFileCircleInfo = faFileCircleInfo;
  errorImage: boolean = false;
  errorImage2: boolean = false;

  activeListOption: number = 1;
  showLoadingTemplate: boolean = false;
  separador: boolean = true;

  loaderImage: boolean = true;
  loaderImage2: boolean = true;

  modalPdf: boolean = false;
  isDownload: boolean = false;
  primeraVez: boolean = true;
  isDownloadDisabled: boolean = true;
  loaderIcon: boolean = false;

  zoomLevel: number = 1; // Nivel inicial de zoom
  offsetY: number = 0; // Desplazamiento vertical para evitar que el contenido se oculte
  faPlus = faPlus;
  faMinus = faMinus;

  showSnackBar = false;
  typeSnackBar = 'error';
  tituloSnackBar = 'Factura Aprobada';
  mensajeSnackBar = 'La Factura ha sido aprobada con éxito.';

  totalRecibidoRecepciones: number = 0;
  totalNetoPagarAnticipo: number = 0;
  totalNetoPagarRetencion: number = 0;
  tablaDetalleAvances: any = {
    retnciones: 0,
    devolucion: 0,
    descuento: 0,
    total: 0
  };

  constructor(private helpersServices: HelpersService, private cd: ChangeDetectorRef,
    private impresionServices: ImpresionService, 
    private facturaService: FacturaService) {

  }


  ngAfterViewInit() {
    //this.loadPreview();
    //this.loadPreviewFactura();
  }

  showDetailNotas() {
    this.showDataNotas = !this.showDataNotas;
    this.iconTotalNotas = (!this.showDataNotas) ? faChevronDown : faChevronUp;
  }

  showDetailSolicitudes() {
    this.showDataPendientes = !this.showDataPendientes;
    this.iconTotalPendiente = (!this.showDataPendientes) ? faChevronDown : faChevronUp;
  }

  isOdd(data: any): boolean {
    return this.helpersServices.esImpar(data);
  }

  cnahgeList(evt: any) {
    if (evt === "tab1") {

    }
    if (evt === "tab2") {
      if (this.primeraVez) {
        this.primeraVez = false;
        this.getListDetalleAvancesAsociados();
        this.getListDetalleAnticipoAsociados();
        this.getListDetalleRetencionAsociados();
        setTimeout(() => {
          this.carouselContentDetallado = [{ content: this.itemDetallado1, title: "Ordenes de Compra" }, { content: this.itemDetallado2, title: "Ordenes de Compra" }, { content: this.itemDetallado3, title: "Ordenes de Compra" }]
        }, 1);
      }
    }
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['detalleFact']) {
      this.detalleFact = changes['detalleFact'].currentValue;
      if (this.detalleFact.IdOrgC) {
        this.getListDetalleOCAsociados();
      }
    }
    if (changes['listDocAsociados']) {
      this.listDocAsociados = changes['listDocAsociados'].currentValue;
      this.dataListado.listTable = this.listDocAsociados;
      this.loadPreviewFactura();
      this.dataConfigListCheck.config[0].isCheckHeaderAllDisabeld = this.esDisabledHeaderCheck();
    }
  }

  esDisabledHeaderCheck():boolean{
    return this.listDocAsociados.every(item => item.CantidadAdjuntos === 0);
  }

  filtrarPorIdTipoDoc(idTipoDoc: number) {
    return this.listDocAsociados.find(item => item.IdTipoDoc === idTipoDoc) || null;
  }

  loadPreviewFactura() {
    const restDocFactura = this.filtrarPorIdTipoDoc(TipoDocumento.Factura);
    if (restDocFactura) {
      this.errorImage = false;
      this.errorImage2 = false;
      this.impresionServices
        .obtenerDocumentoImpresion(this.detalleFact.IdOrgC, this.detalleFact.IdDoc, TipoDocumento.Factura, 0, restDocFactura.FolioUnico, restDocFactura.RutEmisor, restDocFactura.TipoDocTributario, restDocFactura.EsDte)
        .subscribe({
          next: (response) => {
            if (response) {
              this.loaderImage = false;
              this.thumbnail = response.ThumbnailBuffer;
              this.fullImage = response.ImagenBuffer;
              this.pdfSource = response.ArchivoBuffer;
              this.listDocAsociados[0].loader = false;
              this.listDocAsociados[0].error = false;
              this.listDocAsociados[0].fullImage = response.ImagenBuffer;
              this.listDocAsociados[0].thumbnail = response.ThumbnailBuffer;
              this.listDocAsociados[0].pdfSource = response.ArchivoBuffer;
            }
          },
          error: (err) => {
            this.loaderImage = false;
            this.errorImage = true;
            this.listDocAsociados[0].loader = false;
            this.listDocAsociados[0].error = true;
          },
        });
    }
  }

  getListDetalleOCAsociados() {
      this.facturaService.obtenerDetalleOcAsociados(this.detalleFact.IdOrgC, this.detalleFact.IdDoc, TipoDocumento.OC).subscribe((response: DetalleOcAsociada) => {
        if (response.ListadoOc) {
          this.dataListadoRelacion.listTable = response.ListadoOc;
          this.totalRecibidoRecepciones = response.TotalOcAsociadas;
        }
      });
  }

  getListDetalleAvancesAsociados() {
    this.facturaService.obtenerDetalleAvancesAsociados(this.detalleFact.IdOrgC, this.detalleFact.IdDoc, TipoDocumento.Avance).subscribe((response: DetalleAvanceAsociado) => {
      if (response.ListadoAvances) {
        this.dataListadoAvance.listTable = response.ListadoAvances;
        this.tablaDetalleAvances.retnciones = response.DevolucionRetencion;
        this.tablaDetalleAvances.devolucion = response.DevolucionAnticipo;
        this.tablaDetalleAvances.descuento = response.Descuentos;
        this.tablaDetalleAvances.total = response.TotalPagoNeto;
      }
    });
  }

  getListDetalleAnticipoAsociados() {
    this.facturaService.obtenerDetalleAnticipoAsociados(this.detalleFact.IdOrgC, this.detalleFact.IdDoc, TipoDocumento.Anticipo).subscribe((response: DetalleAnticipoAsociado) => {
      if (response.ListaAnticipos) {
        this.dataListadoEstadoAnticipo.listTable = response.ListaAnticipos;
        this.totalNetoPagarAnticipo = response.TotalMontoPagoAnt;
      }
    });
  }

  getListDetalleRetencionAsociados() {
    this.facturaService.obtenerDetalleRetencionesAsociados(this.detalleFact.IdOrgC, this.detalleFact.IdDoc, TipoDocumento.Retencion).subscribe((response: DetalleRetencionAsociada) => {
      if (response.ListaRetenciones) {
        this.dataListadoEstadoRetencion.listTable = response.ListaRetenciones;
        this.totalNetoPagarRetencion = response.TotalMontoPagoRet;
      }
    });
  }

  clickPressDropdown(event: any) {
    this.opcionesList?.[0] && (this.opcionesList[0].select = false);
    if (event.value == 1) {
      this.iconList = faGridHorizontal;
      this.activeListOption = 1;
      this.isDownload = false;
    } else if (event.value == 2) {
      this.iconList = faList;
      this.activeListOption = 2;
      this.isDownload = true;
    } else {
      this.iconList = faListTree;
      this.activeListOption = 3;
      this.isDownload = false;
    }
  }

  showDataValue() {
    this.isPopupVisible = !this.isPopupVisible;
  }

  openModalPdfCarrucel(item: any) {
    this.nameFileDownload = item.DescripcionDocumentoNroDocumento+'.pdf';
    this.pdfSourceView = item.pdfSource;
    this.modalPdf = true;
  }

  openModalPdf(type: number = 1) {
    if (type != 1) {
      this.pdfSourceView = this.pdfSource2;
    } else {
      this.nameFileDownload = `Factura ${this.detalleFact.NumeroFactura}.pdf`;
      this.pdfSourceView = this.pdfSource;
    }
    this.modalPdf = true;
  }

  clikCloseModal(evt: any) {
    this.modalPdf = false;
  }

  downloadPDF() {
    const link = document.createElement('a');
    link.href = this.pdfSourceView;
    link.download = this.nameFileDownload;
    link.click();
  }

  clickPress(event: any) {
    const arrayDoc: string[] = [];
    this.listDocAsociados.forEach(DocumentoAsociado => {
      if(DocumentoAsociado.CantidadAdjuntos != 0 && DocumentoAsociado.check){
        arrayDoc.push(`${DocumentoAsociado.IdDoc}-${DocumentoAsociado.IdTipoDoc}`);
      }
    });
    if(arrayDoc.length > 0){
      this.loaderIcon = true;
      this.typeSnackBar = "info";
      this.tituloSnackBar = "Descarga en progreso";
      this.showSnackBar = true;
      this.mensajeSnackBar = "Descargando los archivos seleccionados";
    }
    const nuevoAttach = new DatosDocumentoAttach(this.detalleFact.IdOrgC, arrayDoc);
    this.facturaService.ObtenerDocumentosAdjuntos(nuevoAttach).subscribe({
      next: (response: RespuestaDocumentoAttach) => {
        this.helpersServices.descargarArchivoBase64(response.ArchivoBuffer, response.Nombre);
        this.loaderIcon = false;
        this.typeSnackBar = "success";
        this.tituloSnackBar = "Archivos descargados";
        this.mensajeSnackBar = "Los archivos se han descargado correctamente";
        setTimeout(() => {
          this.showSnackBar = false;
        }, 7000);
      },
      error: (error) => {
        this.loaderIcon = false;
        this.typeSnackBar = "error";
        this.tituloSnackBar = "Error: Descargar archivo";
        this.mensajeSnackBar = "No se han podido descargar los archivos seleccionados. Por favor, intenta nuevamente";
        setTimeout(() => {
          this.showSnackBar = false;
        }, 7000);
      },
      complete: () => {
      }
    });
  }

  clickLabelChip(event: any){
    if(event.itemKey == "xml"){
      if(event.itemTable.error == false && !event?.itemTable.fullImage){
      }else{
        const link = document.createElement('a');
        link.href = event?.itemTable.pdfSource;
        link.download = event.itemTable.DescripcionDocumentoNroDocumento;
        link.click();
      }
    }
    if(event.itemKey == "CantidadAdjuntos"){
      this.listDocAsociados[event.position].loaderAdjuntos = true;
      const nuevoAttach = new DatosDocumentoAttach(this.detalleFact.IdOrgC,[`${event.itemTable.IdDoc}-${event.itemTable.IdTipoDoc}`]);
      this.facturaService.ObtenerDocumentosAdjuntos(nuevoAttach).subscribe({
        next: (response: RespuestaDocumentoAttach) => {
          this.helpersServices.descargarArchivoBase64(response.ArchivoBuffer, response.Nombre);
          //event.loaderAdjuntos = false;
          this.listDocAsociados[event.position].loaderAdjuntos = false;
        },
        error: (error) => {
          this.listDocAsociados[event.position].loaderAdjuntos = false;
          this.showSnackBar = true;
          this.typeSnackBar = "error";
          this.tituloSnackBar = "Error: Descargar archivo";
          this.mensajeSnackBar = "No se han podido descargar los archivos seleccionados. Por favor, intenta nuevamente";
          setTimeout(() => {
            this.showSnackBar = false;
          }, 7000);
        },
        complete: () => {
        }
      });
    }
  }

  selectItemCheck(event: any) {
    if(event.item.CantidadAdjuntos == 0){
      return;
    }
    this.dataListado.listTable[event.index].check = event.value;
    this.isDownloadDisabled = !this.dataListado.listTable.some((documento: { check: boolean }) => documento.check === true);
    var isFalseChek = !this.dataListado.listTable.some((documento: { check: boolean }) => documento.check === false);
    this.dataConfigListCheck.config[0].isLineCkeck = !this.isDownloadDisabled;
    this.dataConfigListCheck.config[0].isCheckHeaderAll = isFalseChek;
  }

  selectItemAll(event: boolean) {
    this.dataListado.listTable.forEach(DocumentoAsociado => {
      if(DocumentoAsociado.CantidadAdjuntos != 0){
        DocumentoAsociado.check = event;
      }
    });
    this.isDownloadDisabled = !event;
    this.dataConfigListCheck.config[0].isCheckHeaderAll = event;
    this.dataConfigListCheck.config[0].isLineCkeck = event;
  }

  closeSnackBar(event: any) {
    this.showSnackBar = false;
  }

  zoomIn(): void {
    if (this.zoomLevel < 3) {
      this.zoomLevel += 0.1;
      this.adjustOffset();
    }
  }

  zoomOut(): void {
    if (this.zoomLevel > 1) { 
      this.zoomLevel -= 0.1;
      this.adjustOffset();
    }
  }

  private adjustOffset(): void {
    this.offsetY = (this.zoomLevel - 1);
  }

}